import React, { Component } from 'react';

import './styles.scoped.scss';

class CollectionSummary extends Component {
  constructor() {
    super();
    this.state = {
      tab: 1,
    };
  }

  render() {
    const summary = this.props.summary;
    return (
      <>
        <section className="widget dsr-table grid">
          <header />
          <main>
            <table className="dsr" data-name="Collection Summary">
              <thead>
                <tr data-header={true}>
                  <th className="alert-brand" colSpan="2">
                    Collection Summary
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td> Cash</td>
                  <td>
                    {/* {new Intl.NumberFormat('en-IN', {
                      style: 'currency',
                      currency: 'INR',
                    }).format(summary.all_incomes || 0)} */}
                  </td>
                </tr>
                <tr>
                  <td>Wallet 1</td>
                  <td>
                    {/* {new Intl.NumberFormat('en-IN', {
                      style: 'currency',
                      currency: 'INR',
                    }).format(summary.all_expenses || 0)} */}
                  </td>
                </tr>
              </tbody>
            </table>
          </main>
        </section>
      </>
    );
  }
}
export default CollectionSummary;
